import { DEFAULT_FLEXIBLE_DURATION_RANGE } from 'constants/search'

export type ListingDrawerHotelFlexibleNights =
  Exclude<
    DEFAULT_FLEXIBLE_DURATION_RANGE,
    DEFAULT_FLEXIBLE_DURATION_RANGE.EMPTY
  >

export type ListingDrawerHotelDateSelection =
  | {
    type: 'specific'
    checkIn: string
    checkOut: string
  }
  | {
    type: 'flexible'
    flexibleMonths?: string
    flexibleNights: ListingDrawerHotelFlexibleNights
    userSelectedFlexibleMonths: boolean
  }
  | {
    type: 'anytime'
  }

export function isListingDrawerHotelDateSelection(
  value: unknown,
): value is ListingDrawerHotelDateSelection {
  if (!value || typeof value !== 'object') return false

  const type = (value as ListingDrawerHotelDateSelection).type
  return type === 'specific' || type === 'flexible' || type === 'anytime'
}

const HOTEL_FLEXIBLE_NIGHTS: ReadonlySet<string> = new Set(
  Object.values(DEFAULT_FLEXIBLE_DURATION_RANGE).filter(
    (value): value is ListingDrawerHotelFlexibleNights =>
      value !== DEFAULT_FLEXIBLE_DURATION_RANGE.EMPTY,
  ),
)

export function isHotelFlexibleNights(
  value: string,
): value is ListingDrawerHotelFlexibleNights {
  return HOTEL_FLEXIBLE_NIGHTS.has(value)
}
